import { useState } from 'react';
import { useRequest } from 'src/hooks';
const useKvsLinks = () => {
  const [kvsLinks, setKvsLinks] = useState(null);
  const request = useRequest();
  /**
   *
   * @param {object} value
   */
  async function viewKvsLinks(primaryData) {
    if (!primaryData) return;

    const { jid = '', keys = '' } = primaryData;

    const payloadData = {
      keys: [keys]
    };
    const { success, error, data, isCancelled } = await request.post(
      '/trans/jv/' + jid + '/independent-kvs/items',
      payloadData
    );
    if (!success && isCancelled) return;
    else if (!success) {
      console.log('Error Retrieving Data');
      return;
    } else setKvsLinks(data[0]?.value);
    return;
  }

  function closeKvsLinks() {
    setKvsLinks(null);
  }

  return { viewKvsLinks, closeKvsLinks, kvsLinks };
};

export default useKvsLinks;
